import React, { useState } from "react"
import styled from "styled-components"
import { useInViewEffect } from "react-hook-inview"
import { GatsbyImage } from "gatsby-plugin-image"

const AnimatedImage = styled.div`
  width: 100%;
  position: relative !important;
  overflow: visible !important;
  padding: 0 1rem calc(56.25%) 0;

  .image-inner {
    position: absolute !important;
    height: 100%;
    width: 100%;

    :after {
      position: absolute;
      height: 100%;
      width: 100%;
      content: "";
      /* top:${props => props.offsetY};
        right:${props => `-` + props.offsetX}; */
      top: 1rem;
      right: -1rem;
      /* background:var(--red); */
      background: ${props => `var(--` + props.color + `)`};
      z-index: 0;
      transform: translate(-1rem, -1rem);
      /* transform:translate(-${props => props.offsetX}, -${props =>
        props.offsetY} ); */
      transition: 0.5s all ease-in-out;
    }
  }

  &.active {
    .image-inner:after {
      transform: translate(0, 0);
    }
  }

  .gatsby-image-wrapper {
    position: absolute !important;
    height: 100% !important;
    width: 100% !important;
    overflow: visible !important;

    img {
      z-index: 1;
    }
  }
`

export default function AnimatedImageComp({
  imgSrc,
  offsetX,
  offsetY,
  color,
  wrapperWidth,
  objectPosition,
}) {
  const [isVisible, setIsVisible] = useState(false)
  console.log(objectPosition)

  const ref = useInViewEffect(
    ([entry], observer) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active")
      }
      setIsVisible(entry.isIntersecting)
    },
    { threshold: 0.75 }
  )

  return (
    <AnimatedImage
      ref={ref}
      offsetX={offsetX}
      offsetY={offsetY}
      color={color}
      wrapperWidth={wrapperWidth}
      className="image-wrapper"
    >
      <div className="image-inner">
        <GatsbyImage image={imgSrc} objectPosition={objectPosition} />
      </div>
    </AnimatedImage>
  )
}
